module.exports = __webpack_public_path__ + "static/media/calendar-icon-selected.3303b30d.svg";